import React from 'react'
import { Box, Button, styled } from '@mui/material'

import { useTranslation } from 'react-i18next'
import { tokens } from 'src/styles/materialTheme'
import { Styles } from 'src/types'
import { Heading } from 'src/components/typography'
import SearchBox from 'src/rsmCoreComponents/components/Search/SearchBox'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const styles: Styles = {
  searchAndAssignSection: () => ({
    backgroundColor: tokens.colors.white,
    marginTop: '2.5rem',
    marginLeft: '1.25rem',
    marginRight: '1.25rem',

    paddingTop: '2.875rem',
    paddingLeft: '2.5rem',
    paddingRight: '2.5rem',
    paddingBottom: '2.875rem',
  }),
  topContentHolder: (theme) => ({
    display: 'flex',
    paddingBottom: '1.125rem',

    [theme.breakpoints.only('mobile')]: {
      display: 'block',
    },
  }),
  topContentLeftSide: (theme) => ({
    width: '75%',
    float: 'left',

    [theme.breakpoints.only('mobile')]: {
      float: 'none',
      width: '100%',
      paddingBottom: '1.125rem',
    },
  }),
  topContentRightSide: (theme) => ({
    width: '25%',
    float: 'right',
    textAlign: 'right',

    [theme.breakpoints.only('mobile')]: {
      float: 'none',
      width: '100%',
      textAlign: 'left',
    },
  }),
  header: () => ({
    paddingBottom: '2rem',
  }),
  searchBox: () => ({
    maxWidth: '35rem',
  }),
  addUserLink: (theme) => ({
    fontFamily: 'prelo-book',
    fontSize: '1rem',
    color: theme.palette.secondary.main,
    fontWeight: '800',
    textDecoration: 'underline',
  }),
  tableContent: () => ({}),
}

const StyledPlus = styled(FontAwesomeIcon)(() => ({
  paddingRight: '0.25rem',
}))

const SearchAndAssignLayout = () => {
  const { t } = useTranslation()

  return (
    <Box sx={styles.searchAndAssignSection}>
      <Box sx={styles.topContentHolder} id="top">
        <Box sx={styles.topContentLeftSide} id="left">
          <Box sx={styles.header}>
            <Heading variant="h1" testId="Hed_SearchAssign_Title">
              {t('Questionnaire.SearchAssign.PageHeader')}
            </Heading>
          </Box>
          <Box sx={styles.searchBox}>
            <SearchBox
              setFilter={() => {}}
              placeholderText={t(
                'Questionnaire.SearchAssign.TextboxPlaceholderText',
              )}
              testId="Txt_Questionnaire_Assign_Search"
            />
          </Box>
        </Box>
        <Box sx={styles.topContentRightSide} id="right">
          <Button
            data-testid="Btn_SearchAssign_AddUser"
            onClick={() => {}}
            sx={styles.addUserLink}
            role="link">
            <StyledPlus icon={faPlus} />
            {t('Questionnaire.SearchAssign.AddUser')}
          </Button>
        </Box>
      </Box>
      <Box sx={styles.tableContent} id="table">
        Add a table
        {/* Add table here */}
      </Box>
    </Box>
  )
}

export default SearchAndAssignLayout
